<template>
  <div class="action-bar__summary">
    <div class="action-bar__summary-box action-bar__summary-box--product">
      <div class="action-bar__summary-product">
        <div class="action-bar__summary-product-image">
          <media
            v-if="mainProductImage"
            :media="mainProductImage"
            :cols="[3, 3, 6]"
            :lazyload="true"
          />
        </div>
        <div class="action-bar__summary-product-details">
          <h4 class="action-bar__summary-product-title">
            <span>{{ cartItem?.family }}</span>
            <span>{{ cartItem?.modelName }}</span>
          </h4>
          <div class="action-bar__summary-product-price-amount">
            <div class="action-bar__summary-product-meta">
              <amount-input
                :model-value="amount"
                readonly
                :label="
                  $textDictionary['pdp.amount.label'] ?? 'pdp.amount.label'
                "
              />
            </div>
            <div
              v-if="cartItem?.priceText"
              class="action-bar__summary-product-price"
            >
              <price-element
                :current-price="cartItem.priceText"
                alignment="left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="action-bar__summary-box action-bar__summary-box--cta">
      <div class="action-bar__summary-cart">
        <div class="action-bar__summary-cart-subtotal">
          {{
            $textDictionary['actionBar.shoppingCartButton.tempText'] ??
            'actionBar.shoppingCartButton.tempText'
          }}
        </div>
        <div class="action-bar__summary-cart-actions">
          <Button
            :style-type="'attraction'"
            size="medium"
            :expand="true"
            @click="$emit('go-to-cart')"
          >
            {{
              $textDictionary['actionBar.shoppingCartButton'] ??
              'actionBar.shoppingCartButton'
            }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  Button,
  Media,
  PriceElement,
  AmountInput
} from '@hypercodestudio/basler-components';
import type { DecoratedProduct } from '~/utils/shop/DecoratedProduct';
import { useCartStore } from '~/stores/cartStore/cartStore';
import { formatMoney } from '~/utils/shop/formatMoney';

const { $textDictionary, $locale, $globalPageSettings } = useNuxtApp();
const cartStore = useCartStore();

interface Props {
  productSku: string;
  priceText: string;
  cartItem: DecoratedProduct | null;
  amount: number;
}

const props = defineProps<Props>();

// Funktion zum Generieren von Produktbildern mit Fallback
function getProductImage(decoratedProduct: DecoratedProduct | any) {
  if (!decoratedProduct) {
    return null;
  }

  return decoratedProduct.getProductImage?.(
    {
      sizes: '200px',
      widths: [400, 600, 800, 1000],
      aspectRatio: [4, 3]
    },
    $globalPageSettings.value?.defaultProductImage ?? undefined
  );
}

// Bild für das Hauptprodukt generieren
const mainProductImage = computed(() => {
  return getProductImage(props.cartItem);
});

defineEmits<{
  'go-to-cart': [];
  'go-to-checkout': [];
}>();
</script>

<style scoped></style>
